import React from 'react';

export const NotificationDropdown = ({
  coursesWithUnread = [],
  totalUnread = 0,
  onSelectCourse,
  isDark = false,
}) => {
  const hasCourses = coursesWithUnread.length > 0;

  return (
    <div className="w-full font-outfit">
      {/* Header */}
      <div
        className={`px-7 py-3 border-b flex items-center justify-between ${
          isDark
            ? 'bg-slate-800/95 border-slate-700 text-white'
            : 'bg-slate-50 border-slate-200 text-slate-900'
        }`}
      >
        <div className="flex items-center gap-3">
          <h3 className="font-outfit font-bold text-xl tracking-tight leading-none">
            Mensajes sin leer
          </h3>
          {totalUnread > 0 && (
            <span
              className={`font-outfit text-sm font-bold px-2.5 py-0.5 rounded-full shadow-sm leading-none ${
                isDark
                  ? 'bg-rose-900/60 text-rose-200 border border-rose-700'
                  : 'bg-rose-100 text-rose-700 border border-rose-200'
              }`}
            >
              {totalUnread} nuevo{totalUnread > 1 ? 's' : ''}
            </span>
          )}
        </div>
        <span className="font-outfit text-sm font-semibold text-slate-500 dark:text-slate-400 leading-none">
          Por curso
        </span>
      </div>

      {/* Content: List of Courses */}
      {hasCourses ? (
        <>
          <div
            className={`divide-y max-h-[420px] overflow-y-auto ${
              isDark ? 'divide-slate-700' : 'divide-slate-200'
            }`}
          >
            {coursesWithUnread.map((course) => {
              const initials = (course.coursename || 'C')
                .split(' ')
                .map((w) => w[0])
                .slice(0, 2)
                .join('')
                .toUpperCase();

              return (
                <div
                  key={course.courseid}
                  onClick={() => onSelectCourse(course.courseid, course.unreadcount)}
                  className={`px-8 py-5 cursor-pointer transition flex items-center justify-between gap-5 group ${
                    isDark ? 'hover:bg-slate-700/60' : 'hover:bg-blue-50/80'
                  }`}
                >
                  <div className="flex items-center gap-5 min-w-0">
                    <div
                      className={`w-14 h-14 rounded-2xl flex items-center justify-center font-outfit font-bold text-xl shrink-0 group-hover:scale-105 transition-transform ${
                        isDark
                          ? 'bg-blue-900/70 text-blue-200 border border-blue-700'
                          : 'bg-blue-100 text-blue-700 border border-blue-200'
                      }`}
                    >
                      {initials}
                    </div>
                    <div className="min-w-0">
                      <p className="font-outfit text-xl font-bold text-slate-900 dark:text-white truncate group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
                        {course.coursename}
                      </p>
                      <p className="font-outfit text-base font-medium text-slate-500 dark:text-slate-400 truncate mt-1">
                        Abrir chat del curso
                      </p>
                    </div>
                  </div>
                  <div className="flex flex-col items-end gap-1.5 shrink-0">
                    <span className="bg-blue-600 text-white font-outfit text-base font-bold px-4 py-0.5 rounded-full shadow-md">
                      {course.unreadcount}
                    </span>
                    <span className="font-outfit text-sm font-semibold text-blue-600 dark:text-blue-400 group-hover:translate-x-1 transition-transform">
                      Ver chat →
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Footer */}
          <div
            className={`px-8 py-4 border-t text-center ${
              isDark
                ? 'bg-slate-800/80 border-slate-700 text-slate-300'
                : 'bg-slate-50 border-slate-200 text-slate-600'
            }`}
          >
            <span className="font-outfit text-base font-semibold">
              Haz clic en un curso para abrir su chat directamente
            </span>
          </div>
        </>
      ) : (
        /* Empty State */
        <div className="py-16 px-8 text-center">
          <div
            className={`w-20 h-20 mx-auto mb-5 rounded-full flex items-center justify-center shadow-inner ${
              isDark
                ? 'bg-emerald-950/60 text-emerald-400 border border-emerald-800'
                : 'bg-emerald-100 text-emerald-700 border border-emerald-200'
            }`}
          >
            <svg
              className="w-10 h-10"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <h4
            className={`font-outfit text-2xl font-bold tracking-tight ${
              isDark ? 'text-white' : 'text-slate-900'
            }`}
          >
            ¡Estás al día!
          </h4>
          <p className="font-outfit text-base font-medium text-slate-600 dark:text-slate-300 mt-2">
            No tienes mensajes nuevos en tus cursos.
          </p>
        </div>
      )}
    </div>
  );
};
